<template>
  <div :class="$style.root">
    <LayoutSingleTypeHeadingComponent
      :pageData="pageData"
      routeName="publications"
    />

    <SharedThumbnailsPublicationsComponent
      :thumbnails="childData?.data"
    />

    <div
      v-if="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount"
      :class="$style.paginationContainer"
    >
      <button
        :class="$style.paginationButton"
        @click="paginateChildData"
      >
        {{ $t('pagination.loadMore') }}
      </button>
    </div>
  </div>
</template>

<script setup>
const nuxtApp = useNuxtApp()
const routeName = computed(() => {
  return nuxtApp.$getRouteBaseName()
})

const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  },
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.data))
})
</script>

<style module>
.root {
  display: grid;
  grid-row-gap: var(--unit--vertical--sextuple);
}

.paginationContainer {
  composes: container--default from global;
  display: flex;
  justify-content: center;
}

.paginationButton {
  composes: reset-button from global;
  text-transform: uppercase;
}

.paginationButton:hover {
  color: var(--color--pink);
}
</style>
